import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import React, { Fragment, useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { checkExpDate, getCardType, isValidateExpDate } from "../../../../utils";
import { setErrors, setPaymentDetails } from "../topupSlice";
import MaskedCCInput from "./masked_cc_input";
import MaskedExpiryDate from "./masked_expiry_date";
import Checkbox from "@material-ui/core/Checkbox";
import { getToken } from "../../../../../middleware/storage";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MaskedCvv from "../../billpay/payment_details/masked_cvv_input";
import { isCardDuplicate } from "../../../../../../src/components/utils"



const useStyles = makeStyles((theme) => ({
  root: { marginBottom: theme.spacing(2) },
  formControl: {
    marginBottom: theme.spacing(2),
  },
}));

function PaymentDetailsUnregistered(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { setPaymentDetails, paymentDetailsState, handleValidateNext } = props;
  const { cCards } = useSelector((state) => state.topup);
  const [loggedIn, SetLogin] = useState(false);
  const [paymentDetails, updatePaymentDetails] = useState(paymentDetailsState);
  const [errors, updateErrors] = useState({
    name: "",
    cardNumber: "",
    expirationDate: "",
    cvv: "",
  });
  const [duplicateCardText, setDuplicateCardText] = useState("");
  const [disableSaveCard, setDisableSaveCard] = useState(true);

  const handleChange = (prop) => (event) => {
    let isEmpty = false;
    for (const [key, value] of Object.entries(paymentDetailsState)) {
      if (value === "") {
        isEmpty = true;
      }
    }

    let value = event.target.value
    if (prop === "shouldSaveCard") {
      value = event.target.checked;
    }

    if (prop === "cardNumber") {
      if (value.length < 16) {
        setDuplicateCardText("");
        setDisableSaveCard(true);
      } else {
        if (cCards.length > 0) {
          const isCcardDuplicate = isCardDuplicate(cCards, value);
          if (isCcardDuplicate) {
            setDuplicateCardText("This card is already saved for this account.");
            setDisableSaveCard(true);
          } else {
            setDuplicateCardText("");
            setDisableSaveCard(false);
          }
        } else {
          setDuplicateCardText("");
          setDisableSaveCard(false);
        }
      }
    }
    setPaymentDetails({ ...paymentDetails, [prop]: value });
    updatePaymentDetails({ ...paymentDetails, [prop]: value });
  
    const newErrors = {
      name: "",
      cardNumber: "",
      expirationDate: "",
      cvv: "",
    };

    if (prop === "name") {
      newErrors.name = "";

      if (value === "") {
        newErrors.name = "Name cannot be empty";
      }
    } else if (prop === "cardNumber") {
      const cardType = getCardType(value);
      newErrors.cardNumber = "";

      if (value.length < 16) {
        newErrors.value = "Incomplete credit card number";
      }

      if (
        cardType.toUpperCase() !== "VISA" &&
        cardType.toUpperCase() !== "MASTERCARD"
      ) {
        newErrors.cardNumber = "Invalid credit card number";
      }

      if (cardType.toUpperCase() === "VISA") {
        if (value.length !== 13 && value.length !== 16) {
          newErrors.cardNumber = "Incomplete credit card number";
        }
      }

      if (cardType.toUpperCase() === "MASTERCARD") {
        if (value.length !== 16) {
          newErrors.value = "Incomplete credit card number";
        }
      }
    } else if (prop === "expirationDate") {
      newErrors.expirationDate = "";

      if (value === "") {
        newErrors.expirationDate = "Expiration date cannot be empty";
      } else if (value.length < 4) {
        newErrors.expirationDate = "Expiration date is incomplete";
      } else if (!isValidateExpDate(value)) {
        newErrors.expirationDate = "Expiration date is invalid";
      }
    } else if (prop === "cvv") {
      newErrors.cvv = "";

      if (value === "") {
        newErrors.cvv = "CVV cannot be empty";
      } else if (value.length < 3) {
        newErrors.cvv = "CVV must be exactly 3 digits";
      }
    }

    updateErrors({ ...newErrors });
    dispatch(setErrors({ ...newErrors }));
    if (!isEmpty && 
        newErrors.cardNumber == ""&&
        newErrors.cvv == ""&&
        newErrors.expirationDate == ""&&
        newErrors.name == ""
       ) {
      handleValidateNext();
    }
  };

  useEffect(() => {
    async function validateLogin() {
      const token = getToken();
      if (!token) {
        SetLogin(false);
      } else {
        SetLogin(true);
      }
    }
  
    validateLogin();
  }, []);

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid item sm={12} xs={12}>
          <TextField
            id="nameOnCard"
            label="Name on Card"
            helperText={errors.name.length > 0 ? errors.name : ""}
            variant="outlined"
            fullWidth
            required
            value={paymentDetails.name}
            onChange={handleChange("name")}
            error={errors.name.length > 0}
            className={classes.formControl}
            color="secondary"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => {
              e.target.value = e.target.value.match(/[a-zA-Z-'\s]+/); //only accept letters (inclusive of spaces and hyphens and apostrophe for odd names)
            }}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
          <MaskedCCInput
            handleChange={handleChange}
            value={paymentDetails.cardNumber}
            error={errors.cardNumber}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MaskedExpiryDate
            handleChange={handleChange}
            value={paymentDetails.expirationDate}
            error={errors.expirationDate}
          />
        </Grid>
        <Grid item sm={6} xs={12}>
          <MaskedCvv
            handleChange={handleChange}
            value={paymentDetails.cvv}
            error={errors.cvv}
          />
        </Grid>
        <Grid item sm={12} xs={12}>
           {loggedIn && (
             <FormControlLabel
             control={
               <Checkbox id="shouldSaveCard" disabled= {disableSaveCard} checked={paymentDetails.shouldSaveCard} onChange={handleChange("shouldSaveCard")} />
             }
             label={
                   <b>Save Card</b>
             } defaultChecked
           />
          )} 
        </Grid>
        <Grid item sm={12} xs={12}>
           {loggedIn && (
             <FormControlLabel
             control={
               <b>{duplicateCardText}</b>
              }
           />
          )} 
        </Grid>
      </Grid>
    </Fragment>
  );
}
const mapStateToProps = (state) => ({
  paymentDetailsState: state.topup.paymentDetails,
  errors: state.topup.errors,
});

const mapDispatch = { setPaymentDetails };

export default connect(
  mapStateToProps,
  mapDispatch
)(PaymentDetailsUnregistered);
